<template>
  <div class="merchant-info-container">
    <div class="header">
      <div class="title">基本信息</div>
      <!-- <div class="select">
        <el-row :gutter="20">
          <el-col :span="2">
            <div class="label">选择门店</div>
          </el-col>
          <el-col :span="6">
            <el-select v-model="selectedMerchantId" placeholder="请选择">
              <el-option
                v-for="item in shopList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div> -->
    </div>
    <div class="content" v-loading="loading">
      <div class="info">
        <div class="item">
          <p class="title">基础信息</p>
          <ul class="row">
            <li class="label">总店商户名称</li>
            <li class="content">{{merchantInfoEntity.headMerchantName}}</li>
            <li class="label">门店名称</li>
            <li class="content">{{merchantInfoEntity.merchantName}}</li>
            <li class="label">商户编号</li>
            <li class="content">{{merchantInfoEntity.merchantId}}</li>

            <li class="label">门店编号</li>
            <li class="content">{{merchantInfoEntity.shopId}}</li>
            <li class="label">门店状态</li>
            <li class="content">{{merchantInfoEntity.shopStatusValue}}</li>
            <li class="label">门店类型</li>
            <li class="content">{{merchantInfoEntity.shopTypeValue}}</li>

            <li class="label">登录账号</li>
            <li class="content">{{merchantInfoEntity.userName}}</li>
          </ul>
        </div>
        <div class="item">
          <p class="title">门店信息</p>
          <ul class="row">
            <li class="label">法人名称</li>
            <li class="content">{{merchantInfoEntity.legalName}}</li>
            <li class="label">法人身份证</li>
            <li class="content">{{merchantInfoEntity.legalIdcard}}</li>
            <li class="label">联系电话</li>
            <li class="content">{{merchantInfoEntity.contactMobile}}</li>

            <li class="label">所属行业</li>
            <li class="content">{{merchantInfoEntity.mccValue}}</li>
            <li class="label">经营省市</li>
            <li class="content">{{merchantInfoEntity.province}}-{{merchantInfoEntity.city}}</li>
            <li class="label">实际经营地址</li>
            <li class="content">{{merchantInfoEntity.address}}</li>

            <li class="label">营业执照名称</li>
            <li class="content">{{merchantInfoEntity.licenseName}}</li>
             <li class="label">营业执照编号</li>
            <li class="content">{{merchantInfoEntity.license}}</li>
          </ul>
        </div>
        <div class="item">
          <p class="title">结算信息</p>
          <ul class="row">
            <li class="label">开户名称</li>
            <li class="content">{{merchantInfoEntity.bankHolder}}</li>
            <li class="label">账户类型</li>
            <li class="content">{{merchantInfoEntity.bankAccountTypeName}}</li>
            <li class="label">银行卡号</li>
            <li class="content">{{merchantInfoEntity.bankAccount}}</li>

            <li class="label">开户银行</li>
            <li class="content">{{merchantInfoEntity.bankName}}</li>
            <li class="label">银行网点</li>
            <li class="content">{{merchantInfoEntity.bankBranchName}}</li>
            <template v-if="isHeadShop && shopType !== 1">
              <li class="label longer">合并到总店打款</li>
              <li class="content shorter">{{merchantInfoEntity.settleTo === 1 ? '是' : '否'}}</li>
            </template>
          </ul>
        </div>
      </div>
      <div class="fee">
        <div class="item cost-table">
          <p class="title">商户费率配置</p>
          <policy-cost-view
            v-if="merchantPoliciesData.length > 0"
            :policies-data="merchantPoliciesData"
            :is-cost-edit="0"
            :cost-table-type="0"
            :show-template-actions="false"
            :show-policy-tabs="false"
            :show-buttons="false"
            :show-remark="false"
            :show-range="false"
          />
          <div v-else-if="!loading" style="text-align: center; padding: 40px; color: #999;">
            暂无数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryMerchantInfo, getMerchantCostFeeDetail } from '@/api/merchant-info';
import { v160Mixins } from "@/mixins/mixinsv160";
import PolicyCostView from '@/components/PolicyCost/PolicyCostView.vue';

export default {
  name: 'view-info',
  components: {
    PolicyCostView,
  },
  mixins: [v160Mixins],
  data() {
    return {
      activeTab: 0,
      activeTimeType: 0,
      loading: false,
      merchantInfoEntity: {
        shopId: '', // 只需一个值更新，即可带动其他值更新
      },
      shopList: [],
      shopType: 0,
      selectedMerchantIdVar: '',
      merchantCostFeeData: [],
    };
  },
  computed: {
    loginInfo() {
      const str = localStorage.getItem('LOGIN_INFO');
      return JSON.parse(str);
    },
    isHeadShop() { // 当前是否为总店登录
      return this.loginInfo.shopType === 1;
    },
    merchantPoliciesData() {
      if (!Array.isArray(this.merchantCostFeeData) || this.merchantCostFeeData.length === 0) {
        return [];
      }
      return this.merchantCostFeeData.map((item) => {
        const transformFeeList = (list) => {
          if (!Array.isArray(list)) return [];
          return list.map(feeItem => ({
            ...feeItem,
            currentValue: {
              t0FeeDetail: feeItem.t0FeeDetail || {},
              t1FeeDetail: feeItem.t1FeeDetail || {},
            },
          }));
        };

        return {
          ...item,
          policyId: item.policyNo,
          domesticTransAgentCostDetailList: transformFeeList(item.domesticTransAgentCostDetailList),
          foreignCardTransAgentCostDetailList: transformFeeList(item.foreignCardTransAgentCostDetailList),
        };
      });
    },
  },
  methods: {
    getMerchantCostFeeData(merchantId) {
      const loginInfo = this.loginInfo;
      const sessionId = loginInfo.sessionId;
      const targetMerchantId = (this.isHeadShop && loginInfo.merchantId !== merchantId) ? merchantId : '';
      return getMerchantCostFeeDetail({
        sessionId,
        targetMerchantId,
      }).then((res) => {
        if ([0, "0"].includes(res.data.error_code)) {
          const data = res.data.data;
          if (Array.isArray(data)) {
            this.merchantCostFeeData = data;
          } else if (data && typeof data === 'object') {
            this.merchantCostFeeData = [data];
          } else {
            this.merchantCostFeeData = [];
          }
        }
        return res;
      }).catch((err) => {
        this.merchantCostFeeData = [];
        return Promise.reject(err);
      });
    },
    selectedMerchantId() {
      this.selectedMerchantIdVar = this.$route.query.merchantId;
      const params = { merchantId: this.selectedMerchantIdVar };
      this.loading = true;

      Promise.all([
        queryMerchantInfo(params),
        this.getMerchantCostFeeData(this.selectedMerchantIdVar),
      ]).then((result) => {
        if ([0, "0"].includes(result[0].data.error_code)) {
          this.merchantInfoEntity = result[0].data.data;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
  activated() {
    const { shopType, merchantId } = this.$route.query;
    if (!shopType && shopType !== 0) return;
    if (this.shopType !== shopType || this.selectedMerchantIdVar !== merchantId) {
      this.shopType = shopType;
      this.selectedMerchantId();
    }
  },
  created() {
    this.shopType = this.$route.query.shopType;
    this.selectedMerchantId();
  },
};
</script>
<style lang="scss">
.merchant-info-container {
  background-color: #f7f7f7;

  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }

    .select {
      padding: 30px 0;
      margin-bottom: 20px;

      .label {
        height: 38px;
        line-height: 38px;
      }
    }
  }

  > .content {
    .info {
      padding-bottom: 60px;
      padding-left: 50px;
      margin-bottom: 20px;
      background-color: #fff;

      .item {
        .title {
          padding: 30px 0 20px;
          margin: 0;
          font-size: 14px;
          color: #333;
        }

        .row {
          width: 1260px;

          &::after {
            display: block;
            clear: both;
            content: "";
          }

          li {
            // display:table-cell;
            float: left;
            margin-right: -1px;
            margin-bottom: -1px;
          }

          .label {
            width: 120px;
            height: 60px;
            font-size: 14px;
            line-height: 60px;
            color: #43476a;
            text-align: center;
            background-color: #fafafa;
            border: 1px solid #e8eef3;

            &.longer {
              width: 140px;
            }
          }

          .content {
            width: 300px;
            height: 60px;
            font-size: 14px;
            line-height: 60px;
            color: #43476a;
            text-align: center;
            background-color: #fff;
            border: 1px solid #e8eef3;

            &.shorter {
              width: 280px;
            }
          }
        }
      }
    }

    .fee {
      padding-left: 50px;
      margin-bottom: 20px;
      background-color: #fff;

      .item {
        padding-bottom: 60px;

        .title {
          padding: 30px 0 20px;
          margin: 0;
          font-size: 14px;
          color: #333;
        }

        .has-gutter {
          tr {
            background-color: #fafafa;
          }
        }

        .cell {
          text-align: center;
        }
      }

      .cost-table {
        padding-bottom: 40px;
        width: 90%;

        .title {
          padding: 30px 0 20px;
          margin: 0;
          font-size: 16px;
          font-weight: 500;
          color: #333;
        }
      }
    }
  }
}
</style>
